<template>
  <div>
    <b-row class="align-items-end">
      <b-col cols="6" class="bd-right">
        <!-- <b-form-group label="ระยะทาง (กม.)">
          <b-form-input v-model="form.distance" @input="$emit('calRate')" />
        </b-form-group> -->
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="เลือกประเภทการคิดราคางาน">
            <b-form-select
              @input="clearCategoryRoute()"
              v-model="form.rate_type"
              :state="!errors.length ? null : false">
              <b-form-select-option :value="null" disabled>
                กรุณาเลือกประเภทการคิดราคางาน
              </b-form-select-option>
              <b-form-select-option
                :value="rateType.id"
                v-for="rateType in rateTypeList"
                :key="rateType.id">
                {{ rateType.name }}
              </b-form-select-option>
            </b-form-select>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="ราคาน้ำมัน (บาท)">
            <!-- <template v-if="form.rate_type === 'system'">
                <multiselect
                  placeholder="เลือกราคาน้ำมัน"
                  deselect-label=""
                  :options="perliters_prices"
                  :allow-empty="false"
                  @input="$emit('calRate')"
                  v-model="form.price_perliter"
                ></multiselect>
              </template> -->
            <!-- <template v-else> -->
            <b-form-input
              v-model="form.price_perliter"
              :state="!errors.length ? null : false"
              @input="$emit('calRate')" />
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
            <!-- </template> -->
          </b-form-group>
        </ValidationProvider>
        <!-- <b-form-group label="เส้นทางการเดินรถ">
          <b-form-input v-model="form.routes" />
        </b-form-group> -->
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="ระยะทาง (กม.)">
            <b-form-input
              v-model="form.distance"
              @input="$emit('calRate')"
              :state="!errors.length ? null : false" />
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="ราคาขายสุทธิ">
            <b-form-input
              v-model="form.sale_price"
              :disabled="form.rate_type === 'system'"
              :state="!errors.length ? null : false"
              @input="$emit('calRate')" />
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
    <!-- <b-row class="mb-4">
      <b-col cols="6" class="d-flex align-items-center">
        <b-form-group>
          <b-form-radio
            v-model="form.additional_service.type"
            value="true"
            @input="$emit('calRate')"
          >
            เพิ่มค่าบริการ
          </b-form-radio>
          <b-form-radio
            v-model="form.additional_service.type"
            value="false"
            @input="$emit('calRate')"
          >
            ส่วนลด
          </b-form-radio>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-input-group size="lg" append="%">
          <b-form-input
            v-model="form.additional_service.value"
            @input="$emit('calRate')"
            :disabled="!form.sale_price || form.sale_price == 'ไม่พบเรทราคา'"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="10" class="d-flex align-items-center">
        ภาษีมูลค่าเพิ่ม (VAT)
      </b-col>
      <b-col cols="2">
        <b-input-group size="lg" append="%">
          <b-form-input
            v-model="form.vatPercent"
            @input="$emit('calRate')"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col cols="10" class="d-flex align-items-center">
        หักภาษี ณ ที่จ่าย
      </b-col>
      <b-col cols="2">
        <b-input-group size="lg" append="%">
          <b-form-input
            v-model="form.withholdingTaxPercent"
            @input="$emit('calRate')"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <div>ราคาก่อน VAT</div>
        <div>
          <b>{{ form.net_before_vat > 0 ? form.net_before_vat : 0 }} บาท</b>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <div>
          VAT
          {{ form.vatPercent > 0 ? `${form.vatPercent}%` : "" }}
        </div>
        <div>
          <b>{{ form.vatPercent > 0 ? `${form.vat} บาท` : "-" }}</b>
        </div>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <div>ราคารวม VAT</div>
        <div>
          <b>{{
            form.vatPercent > 0 ? `${+form.sale_price + +form.vat} บาท` : "-"
          }}</b>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <div>
          หักภาษี ณ ที่จ่าย
          {{
            form.withholdingTaxPercent > 0
              ? `${form.withholdingTaxPercent}%`
              : ""
          }}
        </div>
        <div>
          <b
            >{{
              form.withholdingTaxPercent > 0
                ? `${form.withholdingTax} บาท`
                : "-"
            }}
          </b>
        </div>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <div>ค่าบริการ</div>
        <div>
          <b
            >{{
              form.additional_service.type === "true"
                ? `${+form.additional_service.value} บาท`
                : "-"
            }}
          </b>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <div>ส่วนลด</div>
        <div>
          <b
            >{{
              form.additional_service.type === "false"
                ? `${+form.additional_service.value} บาท`
                : "-"
            }}
          </b>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between p-4">
        <div>ราคาสุทธิ</div>
        <div>
          <b>{{ form.net }} บาท</b>
        </div>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import jobServices from "@/api/job.service.js";
import { ValidationProvider } from "vee-validate";

export default {
  props: { form: {} },
  data() {
    return {
      rateTypeList: [],
    };
  },
  components: {
    ValidationProvider,
  },
  mounted() {
    this.getRateJobs();
  },
  methods: {
    async getRateJobs() {
      try {
        const response = await jobServices.getRateTypesJobs();
        this.rateTypeList = response.data.data;
      } catch (error) {}
    },
    clearCategoryRoute() {
      // this.form.routes = [];
    },
  },
};
</script>
